import React, { useContext, useEffect } from 'react';
import { MFBeaconButton, MFBeaconModal } from '../Beacon/BeaconComponents';
import { modalCloseNextModalHandler } from '../Modal/utils';
import { getAccountTypeDisplayName } from '../../screens/WelcomeScreen/utils';
import { FlowContext } from '../../core/flow-engine';
import { dispatchOverlayLoad } from '../../analytics/analytics-helper';
import styles from './style.css';

const ApplyBenesModal = ({ setDisplayApplyBenesModal }) => {
  const { appState, closeNextModal } = useContext(FlowContext);
  const { app, accountType } = appState?.store || {};
  const { toIRAAccountType } = app || {};

  useEffect(() => {
    // Send analytics the modal overlay state
    dispatchOverlayLoad('Important notice about Beneficiaries');
  }, []);

  return (
    <MFBeaconModal
      open
      removeCloseButton
      role="dialog"
      id="applyExistingBenesModal">
      <div className="beacon-modal__title">
        Important notice about beneficiaries
      </div>
      <div className="beacon-modal__description">
        If your existing T. Rowe Price{' '}
        {getAccountTypeDisplayName(accountType, toIRAAccountType)} has
        designated beneficiaries, those beneficiaries will remain in place
        following your transfer.
        <br />
        <br />
        If you do not have a beneficiary named, your surviving spouse will be
        considered sole beneficiary. If you do not have a spouse, your estate
        will be considered sole beneficiary. You can add or change your
        beneficiaries on your account dashboard.
      </div>
      <div slot="action-zone" className="modal-btn-container">
        <MFBeaconButton
          variant="primary"
          id="applyExistingBenesUnderstandBtn"
          data-name="applyExistingBenesUnderstandBtn"
          onClick={() => {
            modalCloseNextModalHandler(closeNextModal);
            setDisplayApplyBenesModal(false);
          }}
          label="I Understand"
        />
      </div>
      <style jsx>{styles}</style>
    </MFBeaconModal>
  );
};

export default ApplyBenesModal;
